import React from 'react';
import { useTranslation } from 'react-i18next';

function TrialBanner({ trial }) {
  const { t } = useTranslation('common');

  if (!trial?.isActive) return null;

  const expired = trial.daysRemaining < 0;

  return (
    <div className="mt-6 rounded-xl border border-orange-200 bg-orange-50 p-4 flex items-center justify-between gap-4 flex-wrap">
      <p className="text-sm text-orange-800">
        {expired
          ? t('dashboard.trialBanner.expiredMessage')
          : t('dashboard.trialBanner.message', { days: trial.daysRemaining })}
      </p>
      <button
        type="button"
        onClick={() => window.alert(t('dashboard.trialBanner.upgradeComingSoon'))}
        className="inline-flex items-center rounded-lg bg-gradient-to-r from-orange-500 to-amber-600 px-4 py-2 text-sm font-semibold text-white shadow-md shadow-orange-200 transition hover:from-orange-600 hover:to-amber-700 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:ring-offset-2"
      >
        {t('dashboard.trialBanner.upgrade')}
      </button>
    </div>
  );
}

export default TrialBanner;